import React, { createContext, useContext, useState } from "react";
import { Box, Modal } from "@mui/material";
import Schedule from "../components/Schedule";

const ScheduleContext = createContext(null);

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "1200px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 3,
};

export const ScheduleProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [events, setEvents] = useState([]);
  const [onRangeSelected, setOnRangeSelected] = useState(null);
  const [onChange, setOnChange] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const openSchedule = (lesson, lessons, onChangeCb, onRangeSelectedCb) => {
    setOnRangeSelected(() => onRangeSelectedCb);
    setOnChange(() => onChangeCb);
    prepareEvents(lessons);
    setOpen(true);
    setSelectedUsers([...lesson.students, lesson.teacher]);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const prepareEvents = (lessons) => {
    const formattedEvents = lessons.map((request) => ({
      uid: request.uid,
      id: request.uid,
      title: `[${request.name}]`,
      start: new Date(request.startDttm),
      end: new Date(request.endDttm),
      status: request.status,
      allDay: false,
    }));
    setEvents(formattedEvents);
  };

  const handleChange = (range) => {
    onChange(range);
    setOpen(false);
  };

  const handleRangeSelected = (range) => onRangeSelected(range);

  return (
    <ScheduleContext.Provider value={{ openSchedule }}>
      {children}
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Schedule
            start={null}
            end={null}
            events={events}
            onChange={handleChange}
            onRangeSelected={handleRangeSelected}
            onEventSelected={(e) => console.log("Selected event", e)}
            selectedUsers={selectedUsers}
          />
        </Box>
      </Modal>
    </ScheduleContext.Provider>
  );
};

export const useScheduleService = () => useContext(ScheduleContext);
